import {i18n} from "src/boot/i18n";
import {SOUND_ACTIVE_TYPES} from "./SoundParameters";

export type TIMELINE_CONTENT_DISPLAY_TYPE = 'LEFT' | 'RIGHT' | 'LYRICS';
export type HAND_CONFIGURATION = 'LEFT_HAND' | 'RIGHT_HAND' | 'BOTH_HAND';
export const HAND_CONFIGURATION_DISPLAY_LABEL = new Map<HAND_CONFIGURATION, string>([
  ['LEFT_HAND', i18n.t('visualParameters.handLabels.leftHand') as string],
  ['RIGHT_HAND', i18n.t('visualParameters.handLabels.rightHand') as string],
  ['BOTH_HAND', i18n.t('visualParameters.handLabels.bothHands') as string],
])

export type TimelineContentsDisplayedType = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [DisplayType in TIMELINE_CONTENT_DISPLAY_TYPE]: boolean
}
export const defaultTimelineContentsDisplayed: TimelineContentsDisplayedType = {
  'LEFT': true,
  'RIGHT': true,
  'LYRICS': true,
}

export const TIMELINE_CONTENT_DISPLAY_TYPE_TO_ACTIVE_SOUND_TYPE = new Map<TIMELINE_CONTENT_DISPLAY_TYPE, SOUND_ACTIVE_TYPES>([
  ['LEFT', 'LEFT'],
  ['RIGHT', 'RIGHT'],
  ['LYRICS', 'MELODY'],
])

export const TIMELINE_CONTENT_DISPLAY_LABEL = new Map<TIMELINE_CONTENT_DISPLAY_TYPE, string>([
  ['LEFT', i18n.t('visualParameters.timelineLabels.left') as string],
  ['RIGHT', i18n.t('visualParameters.timelineLabels.right') as string],
  ['LYRICS', i18n.t('visualParameters.timelineLabels.lyrics') as string],
])
export const TIMELINE_CONTENT_DISPLAY_ICONS = new Map<TIMELINE_CONTENT_DISPLAY_TYPE, string>([
  ['LEFT', 'mdi-hand-left'],
  ['RIGHT', 'mdi-hand-right'],
  ['LYRICS', 'mdi-chat-processing'],
])

export class VisualParameters {
  isTimelineContentsDisplayed: TimelineContentsDisplayedType = defaultTimelineContentsDisplayed;

  constructor(isTimelineContentsDisplayed: TimelineContentsDisplayedType) {
    this.isTimelineContentsDisplayed = isTimelineContentsDisplayed;
  }

  static fromHandConfiguration(handConfiguration: HAND_CONFIGURATION, withLyrics: boolean) {
    return new VisualParameters({
      'LEFT': handConfiguration !== 'RIGHT_HAND',
      'RIGHT': handConfiguration !== 'LEFT_HAND',
      'LYRICS': withLyrics,
    })
  }
}
export const defaultVisualParameters = new VisualParameters(defaultTimelineContentsDisplayed);
